import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { testIdConstants } from "@/types/test-id-constants/testIdConstants";
import { Box, Column, Row } from "@stenajs-webui/core";
import {
  FlatButton,
  PrimaryButton,
  SecondaryButton,
  stenaSlidersMini,
} from "@stenajs-webui/elements";
import { SearchFilterPanelHeader } from "@stenajs-webui/filter";
import { Drawer } from "@stenajs-webui/modal";
import { PropsWithChildren, useState } from "react";

export const Filter = ({
  onSearch,
  clearFilter,
  children,
  filterChips,
  filterIsOpen,
  setFilterIsOpen,
  searchDisabled,
}: PropsWithChildren<{
  onSearch: () => void;
  clearFilter: () => void;
  filterChips: React.ReactNode;
  filterIsOpen: boolean;
  setFilterIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  searchDisabled?: boolean;
}>) => {
  return (
    <Box id="filter">
      <Row
        alignItems={"center"}
        indent={3}
        gap={2}
        spacing={1}
        flexWrap={"wrap"}
      >
        <SecondaryButton
          label="Filters"
          leftIcon={stenaSlidersMini}
          onClick={() => setFilterIsOpen(!filterIsOpen)}
        />
        {filterChips}
      </Row>
      <Drawer
        id="RebatesFilter"
        floating
        isOpen={filterIsOpen}
        zIndex={ZIndex.high}
        onRequestClose={() => setFilterIsOpen(false)}
      >
        <SearchFilterPanelHeader
          onRequestClose={() => setFilterIsOpen(false)}
        />
        <Column indent={2} gap={2}>
          {children}
          <Column gap={2}>
            <PrimaryButton
              label={"Search"}
              onClick={onSearch}
              disabled={searchDisabled}
              data-testid={testIdConstants.filterSearchButton}
            />
            <FlatButton label={"Clear filter"} onClick={clearFilter} />
          </Column>
        </Column>
      </Drawer>
    </Box>
  );
};
